module.exports = __webpack_public_path__ + "img/active-12.0c495380.svg";